
export default {
  name: 'pick-landlord',
  props: {
    value: { type: Boolean, default: false },
    roomId: { default: null },
    currentLandlordId: { default: null },
    live: { type: Boolean, default: true }
  },
  data: function () {
    return {
      keyword: '',
      effectiveFrom: '',
      selected: null,
      busy: false,
      kwTimer: null,
      brokenAvatars: {},
      list: [
        { id: null, name: '所有者なし' }
      ]
    };
  },
  computed: {
    opened: function () {
      return this.value;
    }
  },
  watch: {
    value: function (opened) {
      if (opened) {
        this.keyword = '';
        this.effectiveFrom = '';
        this.busy = false;
        this.brokenAvatars = {};
        this.selected = this.currentLandlordId == null ? null : this.currentLandlordId;
        if (this.live) {
          this.loadList();
        } else {
          this.list = [
            { id: null, name: '所有者なし' },
            { id: 1, name: '京蘭　一太朗' },
            { id: 2, name: '真田左衛門佐源信繁' }
          ];
        }
      }
    },
    keyword: function () {
      var t = this;
      clearTimeout(t.kwTimer);
      t.kwTimer = setTimeout(function () {
        if (t.opened && t.live) t.loadList();
      }, 300);
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastMock: function () {
      this.toast('mock：未接线');
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('失敗しました');
    },
    markAvatarBroken: function (item) {
      this.$set(this.brokenAvatars, this.rowKey(item), true);
    },
    rowKey: function (item) {
      return item.id == null ? 'none' : String(item.id);
    },
    close: function () {
      this.$emit('input', false);
    },
    loadList: function () {
      var t = this;
      var params = {};
      var kw = (this.keyword || '').trim();
      if (kw) params.keyword = kw;
      axios.get('landlord', { params: params }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          t.list = [{ id: null, name: '所有者なし' }];
          return;
        }
        var items = (res.data.options && res.data.options.items) || [];
        var list = [{ id: null, name: '所有者なし' }];
        items.forEach(function (item) {
          list.push({
            id: item.id,
            name: item.name || ((item.lastname || '') + (item.firstname || '')),
            avatar_url: item.avatar_url || ''
          });
        });
        t.list = list;
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    normalizeLandlordId: function (val) {
      if (val === null || val === undefined || val === '' || val === 'null') return null;
      var n = Number(val);
      if (!n) return null;
      return n;
    },
    onOk: function () {
      if (!this.live) {
        this.close();
        this.toastMock();
        return;
      }
      var roomId = this.roomId;
      if (!roomId) {
        this.toast('宿が指定されていません');
        return;
      }
      if (this.busy) return;
      var t = this;
      var landlordId = this.normalizeLandlordId(this.selected);
      if (!this.effectiveFrom) {
        this.toast('契約開始日を入力してください');
        return;
      }
      t.busy = true;
      axios.post('room/assignLandlord', {
        room_id: Number(roomId),
        landlord_id: landlordId,
        effective_from: this.effectiveFrom
      }).then(function (res) {
        t.busy = false;
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        t.close();
        t.$emit('assigned', {
          room_id: Number(roomId),
          landlord_id: landlordId,
          item: res.data.options && res.data.options.item
        });
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    onCancel: function () {
      this.close();
    }
  }
};
